module.exports = __webpack_public_path__ + "static/img/s2.0ef5a415.jpg";